import validate from "/var/www/hotlot-staging/web/node_modules/nuxt/dist/pages/runtime/validate.js";
import landing_45gate_45global from "/var/www/hotlot-staging/web/middleware/landing-gate.global.ts";
import manifest_45route_45rule from "/var/www/hotlot-staging/web/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  landing_45gate_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "sanctum-verified": () => import("/var/www/hotlot-staging/web/middleware/sanctum-verified.ts"),
  "sanctum:auth": () => import("/var/www/hotlot-staging/web/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.auth.js"),
  "sanctum:guest": () => import("/var/www/hotlot-staging/web/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.guest.js")
}